export default __webpack_public_path__ + "static/media/sipUp.063f0799.svg";